import React, { useEffect, useState } from 'react';
import {
  faDollar,
  faFilePowerpoint,
  faVideo,
  faComment,
  faBook,
  faClock,
  faCalendarAlt,
  faChalkboardTeacher,
  faGraduationCap
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Headstu from './Headstu';
import axios from '../Axiosinstance';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  makeStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Divider,
  Chip,
  Avatar,
  CardActions
} from '@material-ui/core';
import { buttonBackgroundColor } from '../common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import { baseURLdyte, Password, Username, baseURLdyteMeeting } from '../common';
import Meeting from '../StudentLogin/Meeting';
import { Link, useNavigate, Routes, Route } from 'react-router-dom';
import './Dashboard.css';
import Payment from '../All/Payment';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '1400px',
    marginTop: theme.spacing(4),
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(8), // Increased space for mobile header
      padding: theme.spacing(2),
    },
  },
  card: {
    marginBottom: theme.spacing(4),
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s, box-shadow 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 12px 20px rgba(0,0,0,0.15)',
    },
  },
  courseImage: {
    width: '100%',
    objectFit: 'cover',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
    [theme.breakpoints.up('md')]: {
      height: '180px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '120px', // Reduced height for mobile
    },
  },
  courseTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  sectionTitle: {
    fontWeight: 600,
    margin: theme.spacing(3, 0, 2),
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.75rem',
      margin: theme.spacing(4, 0, 2), // More space around title
    },
  },
  actionButton: {
    margin: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: '8px',
    fontWeight: 500,
    textTransform: 'none',
    minWidth: '160px',
    backgroundColor: buttonBackgroundColor,
    color: 'white',
    '&:hover': {
      opacity: 0.9,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '140px',
      padding: theme.spacing(1),
      margin: theme.spacing(0.5),
      fontSize: '0.875rem',
    },
  },
  paymentCard: {
    padding: theme.spacing(3),
    borderRadius: '12px',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  trainerChip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  statusBadge: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: theme.palette.success.main,
    color: 'white',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  },
  cardContent: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  buttonContainer: {
    width: '100%',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5),
    },
  },
  actionButton: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(1),
    borderRadius: '8px',
    fontWeight: 500,
    textTransform: 'none',
    backgroundColor: buttonBackgroundColor,
    color: 'white',
    '&:hover': {
      opacity: 0.9,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      padding: theme.spacing(0.5, 1),
      minHeight: '36px',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '140px',
    },
  },
}));

const StudentDashboard = () => {
  const [batchId, setBatchId] = useState(null);
  const [studentId, setStudentId] = useState(null);
  const [batchData, setBatchData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [lastRegistrationfeeRemaining, setLastRegistrationFeeRemaining] = useState(null);
  const [totalRegistrationFee, setTotalRegistrationFee] = useState(null);
  const [registrationId, setRegistrationId] = useState(null);
  const [isRegistrationIdFetched, setIsRegistrationIdFetched] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const classes = useStyles();
  const navigate = useNavigate();
  const studentTeacherId = localStorage.getItem('studentteacherid');
  console.log("studentTeacherId", studentTeacherId)

  useEffect(() => {
    const fetchRegistrationId = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/registrationadvances/student/${studentTeacherId}`);
        if (response.data) {
          setRegistrationId(response.data.registration_id);
          setIsRegistrationIdFetched(true);
        }
      } catch (error) {
        console.error('Error fetching registration ID:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (studentTeacherId) {
      fetchRegistrationId();
    }
  }, [studentTeacherId]);

  useEffect(() => {
    if (!isRegistrationIdFetched || !registrationId) return;

    const fetchBatchIds = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/registrationadvances/student/${studentTeacherId}/registration-advances`);
        const batchData = response.data;
        setBatchId(batchData[0].batch.id);
        setStudentId(batchData[0].id);
        setBatchData(batchData);
      } catch (error) {
        console.error('Error fetching batch data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBatchIds();
  }, [isRegistrationIdFetched, registrationId]);

  useEffect(() => {
    if (!isRegistrationIdFetched || !registrationId) return;

    const fetchPaymentData = async () => {
      try {
        const response = await axios.get(`/registrationadvances/payment-info/${registrationId}`);
        setPaymentData(response.data);
      } catch (error) {
        console.error('Error fetching payment data:', error);
        toast.error("Failed to load payment data.");
      }
    };

    fetchPaymentData();
  }, [isRegistrationIdFetched, registrationId]);

  useEffect(() => {
    if (!isRegistrationIdFetched || !registrationId) return;

    const fetchLastRegistrationFeePayment = async () => {
      try {
        const response = await axios.get(`/registrationadvances/paymentDetails-info/${registrationId}`);
        const { lastRegistrationfeedetail, totalregistrationfee } = response.data || {};
        setLastRegistrationFeeRemaining(lastRegistrationfeedetail.registrationFeeRemaining);
        setTotalRegistrationFee(totalregistrationfee);
        // setPaymentData(response.data);
      } catch (error) {
        console.error('Error fetching payment data:', error);
      }
    };

    fetchLastRegistrationFeePayment();
  }, [isRegistrationIdFetched, registrationId]);

  const courseFeeDetails = batchData?.[0]?.courseFeeDetails || [];

  let totalCourseFeePaid = 0;
  let totalRegistrationFeePaid = 0;
  let registrationFeeRemaining = 0;
  let currentRemainingBalance = 0;

  // Filter only 'Paid' entries
  const paidDetails = courseFeeDetails.filter(detail => detail.status === "Paid");

  paidDetails.forEach(detail => {
    if (detail.type === "CourseFee") {
      totalCourseFeePaid += detail.amount || 0;
    }
    if (detail.type === "RegistrationFee") {
      totalRegistrationFeePaid += detail.amount || 0;
    }
  });

  // Get last paid entry for balances
  if (paidDetails.length > 0) {
    const lastEntry = paidDetails[paidDetails.length - 1];
    registrationFeeRemaining = lastEntry.registrationFeeRemaining || 0;
    currentRemainingBalance = lastEntry.courseFeeRemaining || 0;
  }

  const totalPaid = 0;
  const monthlyPaymentsInfo = paymentData?.monthlyPaymentsInfo || [];
  const filteredPayments = monthlyPaymentsInfo.filter(payment => payment.remainingBalance !== 0);


  const extractMeetingId = (link) => {
    if (!link) return '';
    const match = link.match(/id=([a-z0-9-]+)&/i);
    return match ? match[1] : link.split('?id=')[1]?.split('&')[0];
  };

  const addParticipantToMeeting = async (meetingId) => {
    try {
      const basicAuth = btoa(`${Username}:${Password}`);
      const loggedInUserId = localStorage.getItem('userId');
      const userDetailsResponse = await axios.get(`home/user/${loggedInUserId}`);
      const userDetails = userDetailsResponse.data;

      const response = await axios.post(
        `${baseURLdyte}/meetings/${meetingId}/participants`,
        {
          name: userDetails.name || 'student',
          picture: userDetails.profile_Url || 'https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg',
          preset_name: 'group_call_participant',
          custom_participant_id: registrationId.toString(),
        },
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const updatedAuthTokenLink = `${baseURLdyteMeeting}/meeting?id=${meetingId}&authToken=${response.data.data.token}`;
      window.open(updatedAuthTokenLink);
    } catch (error) {
      console.error('Error adding participant:', error);
    }
  };

  const handleShowDialog = () => {
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      handleCloseDialog();
    }
  };

  return (
    <Container className={classes.container}>
      {batchId && studentId && <Headstu batch={batchId} studentId={studentTeacherId} />}

      <ToastContainer position="bottom-right" />
      <Routes>
        <Route path="/meeting/:meetingId" element={<Meeting />} />
        <Route
          path="/"
          element={
            isLoading ? (
              <Loader />
            ) : (
              <div>
                {batchData.map((course, index) => (
                  <Card key={index} className={classes.card}>
                    <Grid container>
                      <Grid item xs={12} md={3}>
                        <img
                          className={classes.courseImage}
                          src={course.batch.courseImage}
                          alt="Course cover"
                          style={{
                            height: '100%',
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} md={9}>
                        <CardContent>
                          {/* <div className={classes.statusBadge}>Active</div> */}
                          <Typography variant="h4" className={classes.courseTitle} gutterBottom>
                            {course.batch.course.split('(')[0]}
                          </Typography>

                          <Grid container spacing={2} alignItems="center">
                            <Grid item>
                              <Chip
                                icon={<FontAwesomeIcon icon={faGraduationCap} size="sm" />}
                                label={`Batch: ${course.intakeId}`}
                                className={classes.trainerChip}
                              />
                            </Grid>
                            {/* <Grid item>
                              <Chip
                                icon={<FontAwesomeIcon icon={faCalendarAlt} size="sm" />}
                                label={`Started: ${new Date(course.batch.startDate).toLocaleDateString()}`}
                                className={classes.trainerChip}
                              />
                            </Grid> */}
                          </Grid>

                          <Divider className={classes.divider} />

                          <Typography variant="h6" gutterBottom style={{ marginTop: '16px' }}>
                            <FontAwesomeIcon icon={faChalkboardTeacher} style={{ marginRight: '8px' }} />
                            Instructors
                          </Typography>

                          <Grid container spacing={1}>
                            {course.batch.trainers.map((trainer, i) => {
                              const Trainer = trainer.replace(/\(\d+\)$/, ''); // Remove trailing (number)
                              return (
                                <Grid item key={`trainer-${i}`}>
                                  <Chip
                                    avatar={<Avatar>{Trainer.charAt(0)}</Avatar>}
                                    label={Trainer}
                                    className={classes.trainerChip}
                                  />
                                </Grid>
                              );
                            })}
                            {course.batch.assessors.map((assessor, i) => (
                              <Grid item key={`assessor-${i}`}>
                                <Chip
                                  avatar={<Avatar>{assessor.charAt(0)}</Avatar>}
                                  label={assessor}
                                  className={classes.trainerChip}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </CardContent>

                        <CardActions className={classes.buttonContainer}>
                          <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={6} sm={3}>
                              <Button
                                style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}
                                fullWidth
                                variant="contained"
                                className={classes.actionButton}
                                startIcon={<FontAwesomeIcon icon={faVideo} />}
                                onClick={() => {
                                  const meetingId = extractMeetingId(course.batch.onlineclasslink);
                                  if (meetingId) {
                                    addParticipantToMeeting(meetingId);
                                  }
                                }}
                              >
                                Join Class
                              </Button>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Button
                                fullWidth
                                variant="contained"
                                className={classes.actionButton}
                                startIcon={<FontAwesomeIcon icon={faComment} />}
                                component={Link}
                                to={`/StudentFeed/${course.batch.id}`}
                                style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}
                              >
                                Feedback
                              </Button>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Button
                                fullWidth
                                variant="contained"
                                className={classes.actionButton}
                                startIcon={<FontAwesomeIcon icon={faFilePowerpoint} />}
                                component={Link}
                                to={`/content/${course.batch.id}`}
                                style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}
                              >
                                Materials
                              </Button>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                              <Button
                                fullWidth
                                variant="contained"
                                className={classes.actionButton}
                                startIcon={<FontAwesomeIcon icon={faDollar} />}
                                style={{ backgroundColor: buttonBackgroundColor, color: 'white' }}
                                onClick={handleShowDialog}
                              >
                                Payments
                              </Button>
                            </Grid>
                          </Grid>
                        </CardActions>
                      </Grid>
                    </Grid>
                  </Card>
                ))}

                <Typography variant="h4" className={classes.sectionTitle}>
                  Payment Overview
                </Typography>

                <Paper elevation={3} className={classes.paymentCard}>
                  <Typography
                    variant="h5"
                    style={{
                      padding: '12px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      marginBottom: '16px',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faClock}
                      style={{
                        marginRight: '10px',
                        color: '#ff6b6b'
                      }}
                    />
                    Payments - Pending
                  </Typography>

                  {monthlyPaymentsInfo.filter(payment => payment.remainingBalance !== 0).length === 0 ? (
                    <div style={{
                      textAlign: 'center',
                      padding: '24px',
                      backgroundColor: '#f9f9f9',
                      borderRadius: '4px'
                    }}>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: 'bold',
                          color: '#4caf50'
                        }}
                      >
                        No current pending payments
                      </Typography>
                    </div>
                  ) : (
                    <div style={{ overflowX: 'auto' }}>
                      <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        backgroundColor: 'white'
                      }}>
                        <thead>
                          <tr style={{
                            borderBottom: '2px solid #e0e0e0',
                            backgroundColor: '#f7f7f7'
                          }}>
                            <th style={{
                              textAlign: 'left',
                              padding: '12px',
                              fontSize: '16px',
                              // fontWeight: '600'
                            }}>Installment</th>
                            <th style={{
                              textAlign: 'left',
                              padding: '12px',
                              fontSize: '16px',
                              // fontWeight: '600'
                            }}>Amount</th>
                            <th style={{
                              textAlign: 'right',
                              padding: '12px',
                              fontSize: '16px',
                              // fontWeight: '600'
                            }}>Balance Due</th>
                          </tr>
                        </thead>
                        <tbody>
                          {monthlyPaymentsInfo.map((payment, index) => (
                            payment.remainingBalance !== 0 && (
                              <tr
                                key={index}
                                style={{
                                  borderBottom: '1px solid #f0f0f0',
                                  '&:hover': {
                                    backgroundColor: '#fafafa'
                                  }
                                }}
                              >
                                <td style={{
                                  padding: '14px 12px',
                                  fontSize: '16px',
                                  // fontWeight: '500'
                                }}>
                                  Installment {index + 1}
                                </td>
                                <td style={{
                                  padding: '14px 12px',
                                  color: '#555',
                                  fontSize: '16px',
                                }}>
                                  ${payment.payment}
                                </td>
                                <td style={{
                                  padding: '14px 12px',
                                  textAlign: 'right',
                                  color: '#ff6b6b',
                                  fontSize: '16px',
                                  // fontWeight: '600'
                                }}>
                                  ${payment.remainingBalance}
                                </td>
                              </tr>
                            )
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </Paper>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={3} className={classes.paymentCard}>
                      <Typography variant="subtitle1">Course Fee Remaining</Typography>
                      <Typography variant="h4" color="error">
                        ${currentRemainingBalance || 0}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={3} className={classes.paymentCard}>
                      <Typography variant="subtitle1">Course Fee Paid</Typography>
                      <Typography variant="h4" color="primary">
                        ${totalCourseFeePaid || 0}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={3} className={classes.paymentCard}>
                      <Typography variant="subtitle1">Registration Fee Remaining</Typography>
                      <Typography variant="h4" color="error">
                        ${registrationFeeRemaining || 0}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={3} className={classes.paymentCard}>
                      <Typography variant="subtitle1">Registration Fee Paid</Typography>
                      <Typography variant="h4" color="primary">
                        ${totalRegistrationFeePaid || 0}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>

                {showDialog && (
                  <Dialog
                    open={showDialog}
                    onClose={handleCloseDialog}
                    disableBackdropClick
                    aria-labelledby="payment-dialog-title"
                    fullWidth
                    maxWidth="lg"
                    onKeyDown={handleKeyDown}
                  >
                    <DialogTitle id="payment-dialog-title">
                      Payment Details
                      <IconButton
                        aria-label="close"
                        onClick={handleCloseDialog}
                        style={{ position: 'absolute', right: 8, top: 8 }}
                      >
                        X
                      </IconButton>
                    </DialogTitle>
                    <DialogContent>
                      <Payment id={studentId} />
                    </DialogContent>
                  </Dialog>
                )}
              </div>
            )
          }
        />
      </Routes>
    </Container>
  );
};

export default StudentDashboard;